import React, { useContext, useEffect, useState } from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  TextField,
  FormGroup,
  Checkbox,
  Box,
  Chip,
} from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import ButtonsGroup from "./ButtonsGroup";
import { RegisterFormContext } from "../../Context/RegisterFormContext";

export default function GuidanceAndSupport() {
  const { formData, setFormData, six, eight, setAvailableScreens } =
    useContext(RegisterFormContext);

  const options = [
    "Internal Assessment",
    "Extend essay",
    "Individual Oral",
    "HL Essay",
  ];

  const handleCheckboxChange = (event) => {
    setFormData((prev) => ({
      ...prev,
      guidanceAndSupport: {
        ...prev.guidanceAndSupport,
        needed: event.target.checked,
      },
    }));
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      guidanceAndSupport: {
        ...prev.guidanceAndSupport,
        [name]: value,
      },
    }));
  };

  function handlePrev() {
    if (six.current) {
      six.current.scrollIntoView({ behavior: "smooth", block: "center" });

      
      setTimeout(() => {
        setFormData((prev) => ({
          ...prev,
          guidanceAndSupport: {
            needed: false,
            assignmentType: [],
            query: "",
            hours: 0,
          },
        }))
          setAvailableScreens((prev) => ({ ...prev, screen7: false }));
        }, 500);
    }
  }

  function handleNext() {
    setAvailableScreens((prev) => ({ ...prev, screen8: true }));
    setTimeout(() => {
      if (eight.current) {
        eight.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }, 300);
  }

  
  const handleDelete = (assignmentType) => {
    setFormData((prev) => ({
      ...prev,
      guidanceAndSupport: {
        ...prev.guidanceAndSupport,
        assignmentType: prev.guidanceAndSupport.assignmentType.filter(
          (assignment) => assignment !== assignmentType
        ),
      },
    }));
  };

  
  const handleSelectChange = (event) => {
    const value = event.target.value;
    if (!formData.guidanceAndSupport.assignmentType.includes(value)) {
      setFormData((prev) => ({
        ...prev,
        guidanceAndSupport: {
          ...prev.guidanceAndSupport,
          assignmentType: [...(prev.guidanceAndSupport.assignmentType || []), value],
        }
      }));
    }
  };
  

  return (
    <div
      style={{
        marginBottom: "1rem",
        minHeight: "80vh",
        paddingTop: "5rem",
        paddingBottom: "5rem",
        display: "flex",
        alignItems: "center",
      }}
    >
      <div style={{ width: "100%" }}>
        <div>
          <Typography
            variant="h6"
            style={{ fontSize: "clamp(1.1rem, 4vw, 2rem" }}
          >
            Do you need assistance in your course work in addition to online lesson?
          </Typography>

          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.guidanceAndSupport?.needed || false}
                  onChange={handleCheckboxChange}
                />
              }
              label="IA / EE / IO / HL Essay"
            />
          </FormGroup>
        </div>

        {formData.guidanceAndSupport?.needed && (
          <>
            <div style={{ marginTop: "1rem" }}>
              <Typography
                variant="h6"
                sx={{ fontSize: "1.1rem", marginBottom: "10px" }}
              >
                Assignment Type?
              </Typography>

              <FormControl fullWidth style={{ minWidth: "200px" }}>
                <InputLabel>Select Assignment Type</InputLabel>
                <Select
                  name="assignmentType"
                  // value={formData.guidanceAndSupport?.assignmentType || ""}
                  onChange={handleSelectChange}
                  label="Select Assignment Type"
                >
                  {options.map((item, index) => (
                    <MenuItem key={index} value={item}>
                      {item}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <Box mt={2}>
            {(formData.guidanceAndSupport.assignmentType || []).map((item) => (
              <Chip
                key={item}
                label={item}
                onDelete={() => handleDelete(item)}
                color="primary"
                style={{ margin: "5px", background: "#3e3e3e" }}
              />
            ))}
          </Box>
            </div>

            <div style={{ marginTop: "1rem" }}>
              <Typography
                variant="h6"
                sx={{ fontSize: "1.1rem", marginBottom: "5px" }}
              >
                Please explain your query
              </Typography>

              <TextField
                fullWidth
                name="query"
                placeholder="Write your query here"
                value={formData.guidanceAndSupport?.query || ""}
                onChange={handleInputChange}
              />
            </div>

            <div
              style={{
                marginTop: "2rem",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Typography variant="h6" sx={{ fontSize: "1.1rem" }}>
                <div>
                No. of Credits
                </div>
                <div style={{fontSize: 'small'}}>
                (1 Credit = 1 Hour)
                </div>
              </Typography>

              <TextField
                name="hours"
                type="number"
                placeholder="8"
                value={formData.guidanceAndSupport?.hours || ""}
                onChange={handleInputChange}
              />
            </div>
          </>
        )}

        <ButtonsGroup
          nextDisabled={
            formData.guidanceAndSupport.needed &&
            (formData.guidanceAndSupport.assignmentType?.length <= 0 ||
              !formData?.guidanceAndSupport?.hours ||
               formData?.guidanceAndSupport?.hours === 0 ||
              !formData?.guidanceAndSupport?.query)
          }
          onPrev={handlePrev}
          onNext={handleNext}
        />
      </div>
    </div>
  );
}
